<template>
  <div  :style="{ width: isMobile && iframeTokenValid ? '100%' : '' }">
    <DocumentDetailMenu>
      <template slot="left-section">
        <zt-icon name="angle-left" />
      </template>
      <template slot="right-section">
        <zt-icon name="download-paper-outline" />
      </template>
    </DocumentDetailMenu>
    <DocumentDetailComponent />
  </div>
</template>

<script>
import DocumentDetailComponent from '../components/DocumentDetail'
import DocumentDetailMenu from '../components/DocumentDetailMenu'
import { useWindowResize } from '@sichern/ui-elements'
export default {
  name: 'DocumentDetail',
  components: {
    DocumentDetailComponent,
    DocumentDetailMenu
  },
  mounted() {
    const header = this.$parent.$parent.$refs['header']
    header.classList.remove('flex')
    header.classList.add('hidden')
    const main = this.$parent.$parent.$refs['main']
    main.classList.remove('pb-20')
    main.classList.remove('pt-16')
  },
   data() {
    return {
       windowResize: useWindowResize(this),
    }
  },
  computed: {
   iframeTokenValid() {
      return this.$iframeMessages.isTokenValid()
    },
    isMobile() {
      return this.windowResize.width < 1024
    },
  },
  beforeDestroy() {
    const header = this.$parent.$parent.$refs['header']
    const main = this.$parent.$parent.$refs['main']
    header.classList.add('flex')
    header.classList.remove('hidden')
    main.classList.add('pb-20')
    main.classList.add('pt-16')
  }
}
</script>
<style scoped>
.item--main {
  grid-row: 6 / span 5;
}

@media only screen and (max-width: 1023px) {
  .item--main {
    grid-row: 6 / span 1;
  }
}
</style>
